import axios from "axios";

export const getServiceAreas = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/service-areas", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getServiceArea = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/service-areas/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createServiceArea = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/service-areas`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateServiceArea = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/service-areas/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteServiceArea = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/service-areas/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};